/* eslint-disable react-hooks/exhaustive-deps */
import { useAtomValue, useSetAtom } from "jotai";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getMyBestScore, getTopUsers } from "../db";
// import { scoreAtom } from "../jotai/game";
import { firebaseInitAtom, screenAtom, userAtom } from "../jotai/service";
import GoogleLoginButton from "./GoogleLoginButton";
import LogoutButton from "./LogoutButton";
import FilledButton from "./StartButton";
import 금메달 from "../assets/first.png";
import 은메달 from "../assets/second.png";
import 동메달 from "../assets/third.png";
import Notice from "./Notice";
import 배경이미지 from "../assets/home.png";
import InventoryButton from "./InventoryButton";

const Home = () => {
  const user = useAtomValue(userAtom);
  const setScreen = useSetAtom(screenAtom);
  const firebaseInit = useAtomValue(firebaseInitAtom);

  const [rank, setRank] = useState<number>(0);

  const [bestScore, setBestScore] = useState(0);
  const [star, setStar] = useState(0);

  // const score = useAtomValue(scoreAtom);

  const getMedalImage = (r: number) => {
    switch (r) {
      case 1:
        return 금메달;
      case 2:
        return 은메달;
      case 3:
        return 동메달;
      default:
        return null;
    }
  };

  useEffect(() => {
    const asyncFunc = async () => {
      if (user?.uid) {
        const info = await getMyBestScore(user);

        const topUsers = await getTopUsers();

        topUsers?.forEach((topUser, idx) => {
          if (topUser.uid === user.uid) {
            setRank(idx + 1);
          }
        });

        setBestScore(info?.bestScore);
        setStar(info?.star || 0);
      }
    };

    asyncFunc();
  }, [user]);

  return (
    <Container>
      <Notice />
      <Title>똥피하기</Title>
      <InventoryButton />
      {firebaseInit && (
        <UserInfo>
          {user?.uid ? (
            <>
              <FlexBox>
                {getMedalImage(rank) && (
                  <MedalImage src={getMedalImage(rank) as string} alt="medal" />
                )}
                <Text>{user.userName}님 안녕하세요</Text>
              </FlexBox>
              <Text>최고 점수: {bestScore}</Text>
              <Text>⭐️: {star}</Text>
            </>
          ) : (
            <Text>로그인을 해주세요.</Text>
          )}
        </UserInfo>
      )}
      <ButtonWrapper>
        <FilledButton
          onClick={() => {
            setScreen("Game");
          }}
        >
          시작하기
        </FilledButton>

        <FilledButton
          onClick={() => {
            setScreen("Ranking");
          }}
        >
          랭킹보기
        </FilledButton>

        {firebaseInit && (
          <>{user?.userName ? <LogoutButton /> : <GoogleLoginButton />}</>
        )}
      </ButtonWrapper>
    </Container>
  );
};

export default Home;

const UserInfo = styled.div`
  font-size: 18px;

  margin-bottom: 10px;
`;

const Container = styled.div`
  position: relative;
  margin: auto;
  max-width: 420px;

  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-image: url(${배경이미지});
  padding: 20px;
`;

const Title = styled.div`
  margin-bottom: 20px;
  font-size: 40px;
  font-weight: 600;
`;

const Text = styled.div``;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  flex-direction: column;
`;

const MedalImage = styled.img`
  width: 20px;
`;

const FlexBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 4px;
`;
